import { render, staticRenderFns } from "./candidateStatusForm.vue?vue&type=template&id=67cd9b28&%23default=true&"
import script from "./candidateStatusForm.vue?vue&type=script&lang=js&"
export * from "./candidateStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports